import { CHART_ENDPOINT, HttpService, httpService } from "../../core/services/http.service";
import { StablecoinLatestDO } from "./pie-chart.models";

export class PieChartService {
  constructor(private httpService: HttpService) { }

  async loadStablecoinsLatest(): Promise<StablecoinLatestDO> {
    const response = await this.httpService.query(`${CHART_ENDPOINT}/graph/latest/stablecoins`, { method: "GET" })
    return await response.json() as StablecoinLatestDO
  }
}

export const pieChartService = new PieChartService(httpService) 